type BackendErrorSource = {
  message?: string;
  data?: Record<string, unknown> | null;
} | null | undefined;

/** Resolves a user-facing message from a `backendCall` result or API error body. */
export function getBackendCallErrorMessage(res: BackendErrorSource): string {
  if (!res) return "Unknown error";
  if (typeof res.message === "string" && res.message.trim()) return res.message;

  const data = res.data;
  if (!data || typeof data !== "object") return "Unknown error";

  if (typeof data.message === "string" && data.message.trim()) return data.message;
  if (typeof data.error === "string" && data.error.trim()) return data.error;

  const errors = data.errors;
  if (Array.isArray(errors) && errors.length > 0) {
    const first = errors[0];
    if (typeof first === "string") return first;
    if (first && typeof first === "object" && "message" in first) {
      const msg = (first as { message?: unknown }).message;
      if (typeof msg === "string" && msg.trim()) return msg;
    }
  }

  return "Unknown error";
}

export function getErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message.trim()) return error.message;
  if (error && typeof error === "object" && "message" in error) {
    const msg = (error as { message?: unknown }).message;
    if (typeof msg === "string" && msg.trim()) return msg;
  }
  return fallback;
}
